import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { FirebaseError } from 'firebase/app';

import { OrganizationFirestoreResponse } from '../types';
import { fetchDocumentFromCollectionByFilter } from './utils';

const COLLECTION_PATH = 'organizations';

export const useGetOrganizationDocumentFromFirestore = (
  key: string,
  value: string,
  options?: UseQueryOptions<OrganizationFirestoreResponse | null, FirebaseError>,
): UseQueryResult<OrganizationFirestoreResponse | null, FirebaseError> => useQuery<
    OrganizationFirestoreResponse | null, FirebaseError>({
      queryKey: [COLLECTION_PATH, key, value] as const,
      queryFn: async (): Promise<OrganizationFirestoreResponse | null> => {
        const data = await fetchDocumentFromCollectionByFilter<OrganizationFirestoreResponse | null>(
          COLLECTION_PATH,
          key,
          value,
        );
        return data
          ? {
            id: data.id,
            hotel: data.hotel,
            languages: data.languages,
            city: data.city,
            associated_attractions: data.associated_attractions,
            socialMediaSettings: data.socialMediaSettings,
            virtual_tour_url: data.virtual_tour_url,
            wifiSettings: data.wifiSettings,
            opinionServicesSettings: data.opinionServicesSettings,
            loyalty_program_url: data.loyalty_program_url,
          }
          : null;
      },
      retry: 0,
      ...options,
    });
